import { render, staticRenderFns } from "./InboundPlan.vue?vue&type=template&id=438d4cfc&scoped=true"
import script from "./InboundPlan.vue?vue&type=script&lang=js"
export * from "./InboundPlan.vue?vue&type=script&lang=js"
import style0 from "./InboundPlan.vue?vue&type=style&index=0&id=438d4cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d4cfc",
  null
  
)

export default component.exports